import { inject, Injectable, signal } from '@angular/core';
import { ApiService } from '../../shared/services';
import { map, Observable, of, tap } from 'rxjs';
import { Municipality } from '../models/municipality.model';

@Injectable({
	providedIn: 'root'
})
export class DomainService {
	private apiService = inject(ApiService);

	readonly nations = signal<any[] | null>(null);
	readonly atecoCodes = signal<any[] | null>(null);
	readonly municipalities = signal<Municipality[]>([]);

	getAllNations() {
		if (this.nations()) {
			return of(this.nations());
		}
		return this.apiService
			.get('nation')
			.pipe(tap(data => this.nations.set(data)));
	}

	getAllMunicipalities() {
		if (this.municipalities().length > 0) {
			return of(this.municipalities());
		}
		return this.apiService.get('municipality').pipe(
			map(res => res.data || []),
			tap(data => this.municipalities.set(data))
		);
	}

	getAllCertifyingAgency() {
		return this.apiService.get('certifying-agency');
	}

	getAllAvailableTemplates() {
		return this.apiService.get('course-template');
	}

	getAllRisk() {
		return this.apiService.get('risk');
	}

	getAllAtecoCode() {
		if (this.atecoCodes()) {
			return of(this.atecoCodes());
		}
		return this.apiService
			.get('ateco-code')
			.pipe(tap(data => this.atecoCodes.set(data)));
	}
}
